import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function CGWMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [phone, setPhone] = useState(props.currState.Number || "");
  const [contractNumber, setContractNumber] = useState(props.contractNumber || "");
  const [last8Vin, setLast8Vin] = useState(props.last8Vin || "");

  const [moreThanEightVin, setMoreThanEightVin] = useState(false);
  const [contractNumShort, setContractNumShort] = useState(false);
  const NAME = "NAME";
  const PHONE = "PHONE";
  const LAST8_VIN = "LAST8_VIN";
  const CONTRACT_NUMBER = "CONTRACT_NUMBER";

  const [searchTypes, setSearchTypes] = useState([
    { key: NAME, value: t("BWC.PolicyInformation.MemberInformationHeader2") },
    { key: PHONE, value: t("ATF.ContractSearch.DropdownOptions6") },
    { key: LAST8_VIN, value: t("ATF.ContractSearch.DropdownOptions3") },
    { key: CONTRACT_NUMBER, value: t("ATF.ContractSearch.DropdownOptions7") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState(props.searchType || NAME);

  useEffect(() => {
    devLog(selectedSearchTypes);
    setFirstName(firstName);
    setLastName(lastName);
    setPhone(phone);
    setContractNumber(contractNumber);
    setLast8Vin(last8Vin);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        contractNumber: contractNumber,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);

    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      if (selectedSearchTypes === "CONTRACT_NUMBER" && contractNumber.length < 6) {
        setContractNumShort(true);
        return;
      }
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        contractNumber: contractNumber,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  const policyNumFormat = (e) => {
    let value = e.target.value.toUpperCase().trim();

    if (value === "") {
      setContractNumber("");
      return;
    }

    let letters = value.replace(/[^A-Z]/g, "").slice(0, 2);
    let numbers = value.replace(/[^0-9]/g, "").slice(0, 6);

    if (letters.length === 0) {
      setContractNumber("");
      return;
    }

    let formattedValue = letters + (letters.length + numbers.length > 3 ? "-" : "") + numbers;

    setContractNumber(formattedValue);
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*First Name*/}
          {selectedSearchTypes === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.PolicyInformation.ConfirmCustomerFirstName")}:</div>
                <input
                  type="text"
                  placeholder={t("ATF.PolicyInformation.ConfirmCustomerFirstName")}
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    e.preventDefault();
                    setFirstName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*Last Name*/}
          {selectedSearchTypes === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.PolicyInformation.ConfirmCustomerLastName")}:</div>
                <input
                  type="text"
                  placeholder={t("ATF.PolicyInformation.ConfirmCustomerLastName")}
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    e.preventDefault();
                    setLastName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*Contract Number*/}
          {selectedSearchTypes === CONTRACT_NUMBER && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.ContractSearch.DropdownOptions7")}:</div>
                <input
                  type="number"
                  placeholder={t("ATF.ContractSearch.DropdownOptions8")}
                  name="contractNumber"
                  className="input form-control required"
                  value={contractNumber}
                  onChange={(e) => {
                    // policyNumFormat(e);
                    setContractNumber(e.target.value?.trim() || "");
                  }}
                  required
                  maxLength={6}
                />
              </div>
              {contractNumShort && <Alert severity="error">{t("description.ContractNumInputErrorMsg")}</Alert>}
            </>
          )}

          {/*Phone*/}
          {selectedSearchTypes === PHONE && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.ContractSearch.DropdownOptions6")}:</div>
                <input
                  type="number"
                  placeholder={t("ATF.ContractSearch.DropdownOptions6")}
                  name="phone"
                  className="input form-control required"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*Last 8 VIN*/}
          {selectedSearchTypes === LAST8_VIN && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.ContractSearch.DropdownOptions3")}:</div>
                <input
                  type="text"
                  placeholder={t("ATF.ContractSearch.DropdownOptions3")}
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  onChange={(e) => {
                    setMoreThanEightVin(false);
                    vinInputLength(e);
                    setLast8Vin(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {moreThanEightVin && <Alert severity="error">{t("description.VinInputErrorMsg")}</Alert>}
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default CGWMemberSearchForm;
